<script>
export default {
  name: 'ClientEmptyState',
  props: {
    title: { type: String, required: true },
    description: {
      type: String,
      default:
        'Entre em contato com o seu profissional para mais informações.',
    },
  },
}
</script>

<template>
  <div class="client-empty-state d-flex flex-column align-items-center text-center mx-auto">
    <div class="client-empty-state__title text-md text-color-800 text-semibold">
      {{ title }}
    </div>
    <div class="text-sm text-color-900">
      {{ description }}
    </div>
  </div>
</template>

<style lang="sass" scoped>
.client-empty-state
  max-width: 600px

  &__title
    margin-bottom: 12px
</style>
